import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {NgxSpinnerService} from "ngx-spinner";
import Me from "../helpers/me";
import App from "../helpers/app";
import Api from "../helpers/api";
import {take} from "rxjs/operators";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import { BreadcrumbService } from '../shared/services/breadcrumb.service';

@Component({
  selector: 'app-usuarios',
  templateUrl: './usuarios.component.html',
  styleUrls: ['./usuarios.component.scss']
})
export class UsuariosComponent implements OnInit {
  apiCall = this.api.new().silent();
  page = 1
  pageSize = 10
  
  usuarios = []
  usuariosOriginal = []
  
  atualizacaoSenha = {
    novaSenha: null,
    confirmaNovaSenha: null,
  }
  
  // Filtros
  filters = {
    nome: null,
    cidade: null,
    login: null,
    periodoCadastroInicio: null,
    periodoCadastroFim: null
  }
  
  novoUsuario = {
    tipoUsuario: null,
    estado: null,
    cidade: null,
    nome: null,
    login: null,
    origemAcesso: 'MUNICIPIO',
    senha: null,
    confirmaSenha: null
  }
  
  tipos = [
    {
      id: '2',
      name: 'Servidor',
    }
  ]
  
  estados = [];
  cidades = [];
  userToUpdate = null
  tipoUsuario = null
  nomeCidade: string = null;
  
  // Propriedades para ordenação
  currentSortColumn: string = '';
  currentSortDirection: string = 'asc';
  
  // Adicionar função Math para uso no template
  Math = Math;
  
  constructor(
    private router: Router,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private me: Me,
    private app: App,
    private api: Api,
    private breadcrumbService: BreadcrumbService
  ) {
  }

  async ngOnInit(){
    const self = this
    
    // Configurar breadcrumbs como componente filho - 3 níveis
    self.breadcrumbService.setMunicipioBreadcrumbs('Usuários');
    
    // Processar query params para filtro por cidade
    self.route.queryParams.subscribe(async (parametros) => {
      if (parametros['nomeCidade']) {
        self.nomeCidade = parametros['nomeCidade'];
        self.filters.cidade = parametros['nomeCidade'];
        console.log('Filtro por cidade aplicado:', self.nomeCidade);
      }
      
      await self.loadData();
    });
  }

  async loadData() {
    const self = this
    self.resetForm()
    
    self.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });

    try {
      const estados = await self.apiCall.get('enderecos/estados').pipe(take(1)).toPromise()
      self.estados = JSON.parse(JSON.stringify(estados));
      
      const usuarios = await self.apiCall.get('users/lista/servidor').pipe(take(1)).toPromise()
      self.usuarios = JSON.parse(JSON.stringify(usuarios));
      self.usuariosOriginal = JSON.parse(JSON.stringify(usuarios));
      
      // Aplicar filtro por cidade se veio por parâmetro
      if (self.nomeCidade) {
        self.applyFilters();
      }
      
    } catch (error) {
      console.error('Erro ao carregar dados:', error);
      await self.app.alert('Erro', 'Erro ao carregar dados dos usuários', 'error');
    } finally {
      self.spinner.hide()
    }
  }

  resetForm() {
    this.atualizacaoSenha = {
      novaSenha: null,
      confirmaNovaSenha: null,
    }
    this.userToUpdate = null
    this.tipoUsuario = null
    this.novoUsuario = {
      tipoUsuario: '2', // Sempre servidor
      estado: null,
      cidade: null,
      nome: null,
      login: null,
      origemAcesso: 'MUNICIPIO',
      senha: null,
      confirmaSenha: null
    }
    this.cidades = []
  }

  applyFilters() {
    this.usuarios = [...this.usuariosOriginal];
    
    if (this.filters.nome) {
      this.usuarios = this.usuarios.filter(u => 
        u.nome && u.nome.toLowerCase().includes(this.filters.nome.toLowerCase())
      );
    }
    
    if (this.filters.cidade) {
      this.usuarios = this.usuarios.filter(u => 
        u.nomeCidade && u.nomeCidade.toLowerCase().includes(this.filters.cidade.toLowerCase())
      );
    }
    
    if (this.filters.login) {
      this.usuarios = this.usuarios.filter(u => 
        u.login && u.login.toLowerCase().includes(this.filters.login.toLowerCase())
      );
    }

    if (this.filters.periodoCadastroInicio && this.filters.periodoCadastroInicio.trim() !== '') {
      const dataInicio = this.convertDateFormat(this.filters.periodoCadastroInicio);
      if (dataInicio) {
        this.usuarios = this.usuarios.filter(usuario => {
          if (usuario.data_cadastro) {
            const dataCadastro = new Date(usuario.data_cadastro);
            return dataCadastro >= new Date(dataInicio);
          }
          return true;
        });
      }
    }

    if (this.filters.periodoCadastroFim && this.filters.periodoCadastroFim.trim() !== '') {
      const dataFim = this.convertDateFormat(this.filters.periodoCadastroFim);
      if (dataFim) {
        this.usuarios = this.usuarios.filter(usuario => {
          if (usuario.data_cadastro) {
            const dataCadastro = new Date(usuario.data_cadastro);
            return dataCadastro <= new Date(dataFim);
          }
          return true;
        });
      }
    }

    // Aplicar ordenação se houver
    if (this.currentSortColumn) {
      this.usuarios = this.sortData(this.usuarios, this.currentSortColumn, this.currentSortDirection);
    }

    this.page = 1; // Reset para primeira página
  }

  clearFilters() {
    this.filters = {
      nome: null,
      cidade: null,
      login: null,
      periodoCadastroInicio: null,
      periodoCadastroFim: null
    };
    this.currentSortColumn = '';
    this.currentSortDirection = 'asc';
    this.usuarios = [...this.usuariosOriginal];
    this.page = 1;
  }

  // Métodos de ordenação
  sortTable(column: string) {
    if (this.currentSortColumn === column) {
      this.currentSortDirection = this.currentSortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.currentSortColumn = column;
      this.currentSortDirection = 'asc';
    }

    this.page = 1; // Reset para primeira página
    this.applyFilters(); // Reaplicar filtros com nova ordenação
  }

  sortData(data: any[], column: string, direction: string): any[] {
    return data.sort((a, b) => {
      let valueA = a[column];
      let valueB = b[column];

      // Tratar valores nulos/undefined
      if (valueA == null) valueA = '';
      if (valueB == null) valueB = '';

      // Converter para string para comparação
      valueA = valueA.toString().toLowerCase();
      valueB = valueB.toString().toLowerCase();

      if (direction === 'asc') {
        return valueA.localeCompare(valueB);
      } else {
        return valueB.localeCompare(valueA);
      }
    });
  }

  // Método para mostrar indicador de ordenação
  getSortIcon(column: string): string {
    if (this.currentSortColumn === column) {
      return this.currentSortDirection === 'asc' ? 'fa-caret-up' : 'fa-caret-down';
    }
    return '';
  }

  // Método para verificar se a coluna está sendo ordenada
  isColumnSorted(column: string): boolean {
    return this.currentSortColumn === column;
  }

  // Converter formato de data de dd/mm/yyyy para yyyy-mm-dd
  convertDateFormat(dateString: string): string | null {
    if (!dateString) return null;
    
    const parts = dateString.split('/');
    if (parts.length === 3) {
      const day = parts[0].padStart(2, '0');
      const month = parts[1].padStart(2, '0');
      const year = parts[2];
      return `${year}-${month}-${day}`;
    }
    return null;
  }

  async deleteUsuario(idUsuario: number) {
    const result = await this.app.confirm('Confirmação', 'Tem certeza que deseja excluir este usuário?', 'Sim', 'Não');
    
    if (result) {
      this.spinner.show(undefined, {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });

      try {
        await this.apiCall.delete(`users/${idUsuario}`).pipe(take(1)).toPromise();
        await this.app.alert('Sucesso!', 'Usuário excluído com sucesso!', 'success');
        await this.loadData();
      } catch (error) {
        console.error('Erro ao excluir usuário:', error);
        await this.app.alert('Erro', 'Erro ao excluir usuário', 'error');
      } finally {
        this.spinner.hide();
      }
    }
  }

  async updateSenha(modal){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    
    try {
      await this.apiCall.get(`users/edicao/senha?idUsuario=${this.userToUpdate.id}&senha=${this.atualizacaoSenha.novaSenha}&tipoUsuario=2`).pipe(take(1)).toPromise()
      await this.app.alert('Tudo certo!', 'Senha atualizada com sucesso!', 'success')
      modal.close('Close click')
      await this.loadData()
    } catch (error) {
      console.error('Erro ao atualizar senha:', error);
      await this.app.alert('Erro', 'Erro ao atualizar senha', 'error')
    } finally {
      this.spinner.hide()
    }
  }
  
  openModal(content, usuario, tipo){
    this.userToUpdate = usuario
    this.tipoUsuario = tipo
    const modal = this.modalService.open(content, { centered: true, size: 'lg' })
  }

  async toggleEstado(){
    this.cidades = []
    try {
      const cidades = await this.apiCall.get('enderecos/estados/cidades?estado='+this.novoUsuario.estado).pipe(take(1)).toPromise()
      this.cidades = JSON.parse(JSON.stringify(cidades));
    } catch (error) {
      console.error('Erro ao carregar cidades:', error);
    }
  }
  
  async insertUsuario(modal){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    
    try {
      // Verificar se usuário já existe
      const verification = await this.apiCall.get('users/verificacao/servidor?login='+this.novoUsuario.login).pipe(take(1)).toPromise()
      if(verification){
        await this.app.alert('Ops', 'Este usuário já existe! informe outro login.', 'error')
        return
      }
      
      await this.apiCall.get(`users/novo?tipoUsuario=2&nome=${encodeURIComponent(this.novoUsuario.nome)}&cidade=${this.novoUsuario.cidade}&senha=${encodeURIComponent(this.novoUsuario.senha)}&login=${encodeURIComponent(this.novoUsuario.login)}&origemAcesso=${this.novoUsuario.origemAcesso}`).pipe(take(1)).toPromise()
      await this.app.alert('Tudo certo!', 'Usuário cadastrado com sucesso!', 'success')
      modal.close('Close click')
      await this.loadData()
    } catch (error) {
      console.error('Erro ao cadastrar usuário:', error);
      await this.app.alert('Erro', 'Erro ao cadastrar usuário', 'error')
    } finally {
      this.spinner.hide()
    }
  }

  async atualizarOrigem(usuario: any, origemAcesso: 'BRPREV' | 'MUNICIPIO') {
    const anterior = usuario.origemAcesso;
    usuario.origemAcesso = origemAcesso;
    try {
      const response: any = await this.apiCall.put('users/origem-acesso', {
        idUsuario: usuario.id,
        origemAcesso,
      }).pipe(take(1)).toPromise();
      if (response && Number(response.status) >= 400) {
        throw new Error(response.error && response.error.message || 'Falha ao atualizar o perfil.');
      }
      await this.app.alert('Tudo certo!', 'Perfil de acesso atualizado.', 'success');
    } catch (error) {
      usuario.origemAcesso = anterior;
      await this.app.alert('Erro', error.message || 'Erro ao atualizar o perfil de acesso.', 'error');
    }
  }
}
